<template>
  <f7-page name="shmu-m-uvod" class="bg-color-white" @page:init="onPageInit" @page:beforein="onPageBeforeIn">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>SHMÚ</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <!-- Page content-->
    <div class="shmu-home">
      <f7-block class="text-align-center mt-1 mb-1">
        <img src="static/shmu/img/shmu.svg" class="img-home">
      </f7-block>
      <!--f7-block strong style="background-color:#fde9e5;" class="no-border no-margin text-align-center font-weight-bold mb-1">
        Skúšobná prevádzka
      </f7-block-->

      <f7-block strong class="no-border no-margin text-align-center mb-1" v-if="isAnyVystraha">

        <f7-block-title class="margin-top-half text-uppercase text-align-center">Aktuálne výstrahy</f7-block-title>

        <f7-block class="shmu-vystrahy-buttons no-margin no-padding">

          <f7-button v-if="meteoVystrahaStupen > 0" large raised  :class="`shmu-button btn-pill shmu-blue ` + class_meteo_vystraha"
                     href="/meteo-vystrahy/">
            <div>Meteo<br>výstrahy <span class="text-color-black" v-if="meteo_selected_region" v-html="meteo_selected_region"></span></div>
          </f7-button>

          <f7-button v-if="hydroVystrahaStupen > 0" large raised  :class="`shmu-button btn-pill shmu-green `+ class_hydro_vystraha"
                     href="/hydro-vystrahy/">
            <div>Hydrologické<br>výstrahy <span class="text-color-black" v-if="hydro_selected_region" v-html="hydro_selected_region"></span></div>
          </f7-button>

          <f7-button v-if="koVystrahaStupen > 0" large raised  :class="`shmu-button btn-pill shmu-brown full ` + class_ko_vystraha"
                     href="/smogovy-system/">
            <div>Smogový varovný systém</div>
          </f7-button>
        </f7-block>

      </f7-block>


      <div class="bg-pocasie padding-top-half padding-bottom-half">
        <f7-block-title class="margin-top-half text-uppercase text-align-center">Počasie</f7-block-title>
        <f7-block class="shmu-home-buttons">

          <f7-button large raised class="shmu-button btn-pill shmu-blue"
                     href="/predpoved-pocasia/">
            <div>Modelová<br>predpoveď</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/aktualne-pocasie/">
            <div>Aktuálne<br>počasie</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/textova-predpoved/">
            <div>Textová<br>predpoveď</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/meteogramy/">
            <div>Meteogramy</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/a-laef/">
            <div>A-LAEF</div>
          </f7-button>


          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/radary/">
            <div>Radary</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/druzice/">
            <div>Družice</div>
          </f7-button>


          <f7-button large raised  :class="`shmu-button btn-pill shmu-blue ` + class_meteo_vystraha"
                     href="/meteo-vystrahy/">
            <div>Meteo<br>výstrahy</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/tlakove-pole/">
            <div>Tlakové pole</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/ozon/">
            <div>Ozón</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/uv-index/">
            <div>UV Index</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     v-if="showSnowInfo"
                     href="/snehove-spravodajstvo/">
            <div>Snehové<br> spravodajstvo</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/webkamery/">
            <div>Web kamery</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/radioaktivita/">
            <div>Rádioaktivita</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-blue"
                     href="/meteo-sucho/">
            <div>Meteorologické<br />sucho</div>
          </f7-button>


        </f7-block>

        <f7-block-title class="margin-top-half text-uppercase text-align-center">Letecká meteorológia</f7-block-title>
        <f7-block class="shmu-home-buttons">
          <f7-button large raised class="shmu-button btn-pill shmu-blue"
                     href="/lms-metar/">
            <div>METAR</div>
          </f7-button>

          <f7-button large raised class="shmu-button btn-pill shmu-blue"
                     href="/lms-taf/">
            <div>TAF</div>
          </f7-button>

          <f7-button large raised class="shmu-button btn-pill shmu-blue"
                     href="/lms-sigmet/">
            <div>SIGMET</div>
          </f7-button>

          <f7-button large raised class="shmu-button btn-pill shmu-blue"
                     href="/lms-surfana/">
            <div>SURFANA</div>
          </f7-button>

        </f7-block>
      </div>

      <div class="bg-voda padding-top-half padding-bottom-half">
        <f7-block-title class="margin-top-half text-uppercase text-align-center  no-margin padding-top-half padding-bottom">Voda</f7-block-title>
        <f7-block class="shmu-home-buttons">

          <f7-button large raised  class="shmu-button btn-pill shmu-green"
                     href="/vodne-stavy/">
            <div>Vodné stavy</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-green"
                     href="/uhrny-zrazok/">
            <div>Úhrny zrážok</div>
          </f7-button>

          <f7-button large raised   :class="`shmu-button btn-pill shmu-green `+ class_hydro_vystraha"
                     href="/hydro-vystrahy/">
            <div>Hydrologické<br>výstrahy</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-green"
                     href="/hydro-spravodajstvo/">
            <div>Hydrologické<br>spravodajstvo</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-green"
                     href="/hydro-situacia/">
            <div>Hydrologická<br>situácia</div>
          </f7-button>

          <f7-button large raised  class="shmu-button btn-pill shmu-green"
                     v-if="showWaterTanks"
                     href="/hydro-nadrze/">
            <div>Teploty<br>vodných<br>nádrží</div>
          </f7-button>

          <f7-button large raised   class="shmu-button btn-pill shmu-green"
                     href="/situacia-na-vodnych-tokoch/">
            <div>Sucho v<br>povrchových<br>vodách</div>
          </f7-button>

          <f7-button large raised   class="shmu-button btn-pill shmu-green"
                     href="/podzemne-vody/">
            <div>Sucho v<br>podzemných<br>vodách</div>
          </f7-button>

          <f7-button large raised   class="shmu-button btn-pill shmu-green full"
                     href="/kvalita-podzemnej-vody/">
            <div>Kvalita podzemnej vody</div>
          </f7-button>

        </f7-block>
      </div>

      <div class="bg-smog padding-top-half padding-bottom-half">

        <f7-block-title class="text-align-center text-uppercase no-margin padding-top-half padding-bottom">Kvalita ovzdušia</f7-block-title>
        <f7-block class="shmu-home-buttons">

          <f7-button large raised   :class="`shmu-button btn-pill shmu-brown full ` + class_ko_vystraha"
                     href="/smogovy-system/">
            <div>Smogový varovný systém</div>
          </f7-button>

          <f7-button large raised   class="shmu-button btn-pill shmu-brown full"
                     href="/kvalita-ovzdusia/">
            <div>Aktuálne koncentrácie</div>
          </f7-button>

        </f7-block>

      </div>

      <div class="bg-none padding-top-half padding-bottom-half">

        <f7-block class="shmu-home-buttons">

          <f7-button large raised   class="shmu-button btn-pill shmu-blue" external
                     href="http://www.shmu.sk/">
            www.shmu.sk</f7-button>


          <f7-button large raised   class="shmu-button btn-pill shmu-blue" external
                     href="https://www.facebook.com/shmu.sk/" icon-f7="logo_facebook">
            &nbsp; Facebook</f7-button>



        </f7-block>

      </div>


      <f7-block strong class="text-small no-border-bottom no-padding-bottom no-margin-bottom">
        <strong>&copy {{ rok }} Slovenský hydrometeorologický ústav</strong><br>
        <span class="text-color-gray">Všetky informácie, texty a elektronické obrázky, ktoré obsahuje tento server http://www.shmu.sk sú duševným vlastníctvom Slovenského hydrometeorologického ústavu
        a nesmú byť reprodukované alebo použité iným spôsobom, ako pre vlastnú potrebu, bez súhlasu SHMÚ.<br>
          Od meteorologických a hydrologických informácií z iného zdroja ako SHMÚ sa dištancujeme a nezodpovedáme za ich kvalitu.</span>
      </f7-block>
      <div class="text-align-right">
        <f7-link popup-open=".home-licencie">
          <small class="text-small padding-top-half padding-right-half padding-bottom-half" style="color:#dddddd">v.{{ ver }}</small>
        </f7-link>
      </div>

    </div>

    <f7-popup class="home-licencie">
      <f7-page>
        <f7-navbar title="Technológie">
          <f7-nav-right>
            <f7-link popup-close>Návrat</f7-link>
          </f7-nav-right>
        </f7-navbar>

        <f7-list class="no-margin-top">
          <f7-list-item title="Údaje: SHMÚ" external link="http://www.shmu.sk/" />
          <f7-list-item title="Rozhranie: Framework7.io" external link="https://framework7.io/" />
          <f7-list-item title="Grafy: Highcharts" external  link="https://www.highcharts.com/" />
          <f7-list-item title="Mapy: Leaflet" external link="https://leafletjs.com/" />
          <f7-list-item title="Mapový podklad: OpenStreetMap" external link="http://osm.org/copyright" />
          <f7-list-item title="Programované pomocou Vue.js" external link="https://vuejs.org/" />
        </f7-list>

      </f7-page>
    </f7-popup>

  </f7-page>



</template>



<script>
import SHMUconf from "../js/SHMUconf";
import Axios from "axios";
const pkg = require('../../package.json');

export default {
  data() {
    return {
      snowInfoEnable: SHMUconf.ENABLE_SNOW_INFO,
      vystrahyData: null,
      isVystrahyLoaded: false,
      meteoVystrahaStupen: 0,
      hydroVystrahaStupen: 0,
      koVystrahaStupen: 0,
      selectedMeteoVystrahyRegion: null,
      selectedHydroVystrahyRegion: null,
      vystrahyLastUpdated: 0,
      class_hydro_vystraha: null,
      class_meteo_vystraha: null,
      class_ko_vystraha: null,
      hydro_region_selected_nazov: null
    }
  },
  computed: {
    ver() {
      return pkg.version
    },
    rok() {
      return new Date().getFullYear();
    },
    showSnowInfo() {
      let rok = new Date().getFullYear();
      let aboveOctober =  new Date(rok, 9, 1); // mesiac -1, teda od 1.10
      let belowMay = new Date(rok, 4, 30); // mesiac -1, teda do 30.5
      let currentDate = new Date();

      if (currentDate <= belowMay) {
        return true;
      }

      if (currentDate >= aboveOctober) {
        return true;
      }

      return false;
    },
    showWaterTanks() {
      let rok = new Date().getFullYear();
      let bellowOctober =  new Date(rok, 9, 1); // mesiac -1, teda od 1.10
      let abovebMay = new Date(rok, 4, 30); // mesiac -1, teda do 30.5
      let currentDate = new Date();

      if (currentDate > abovebMay) {
        return true;
      }

      if (currentDate <= bellowOctober) {
        return true;
      }

      return false;
    },
    meteo_selected_region() {
      if (this.selectedMeteoVystrahyRegion && this.isVystrahyLoaded) {
        return '<small>(' + this.selectedMeteoVystrahyRegion + ')</small>';
      }
      return null;

    },
    hydro_selected_region() {
      if (this.selectedHydroVystrahyRegion && this.isVystrahyLoaded) {
        return '<small>(' + this.hydro_region_selected_nazov + ')</small>';
      }
      return null;
    },
    isAnyVystraha() {

      let is_vystraha = false;


      // METEO VYSTRAHY
      if (this.isVystrahyLoaded && this.vystrahyData.meteo_warnings.length > 0) {

        let meteo_scan = [];
        if (this.selectedMeteoVystrahyRegion) {
          // vyfiltruj
          meteo_scan = this.vystrahyData.meteo_warnings.filter(item => item.region_key === this.selectedMeteoVystrahyRegion);
        } else {
          meteo_scan = this.vystrahyData.meteo_warnings;
        }

        if (meteo_scan.length > 0) {
          let meteo_max_st = 0;
          meteo_scan.forEach(v => {

            let max_vystraha = v.vystrahy.reduce(function (prev, current) {
              return (parseInt(prev.stupen) > parseInt(current.stupen)) ? prev : current
            });
            if (max_vystraha.stupen > meteo_max_st) {
              meteo_max_st = max_vystraha.stupen;
            }

          });

          this.meteoVystrahaStupen = meteo_max_st;
          let add_color = '';
          if (meteo_max_st === 1) {
            add_color = ' text-color-black';
          }
          this.class_meteo_vystraha = 'vystraha-' + meteo_max_st + add_color + ' border-vystraha-' + meteo_max_st;
          is_vystraha = true;
        } else {
          this.class_meteo_vystraha = null;
          this.meteoVystrahaStupen = 0;
        }

      }

      // HYDRO VYSTRAHY
      if (this.isVystrahyLoaded && this.vystrahyData.hydro_warnings.length > 0) {

        let hydro_scan = [];
        if (this.selectedHydroVystrahyRegion) {
          // vyfiltruj
          hydro_scan = this.vystrahyData.hydro_warnings.filter(item => parseInt(item.okres.id_okres) === parseInt(this.selectedHydroVystrahyRegion));
          if (hydro_scan.length > 0) {
            this.hydro_region_selected_nazov = hydro_scan[0].okres.skratka;
          }
        } else {
          hydro_scan = this.vystrahyData.hydro_warnings;
        }

        if (hydro_scan.length > 0) {
          let max_vystraha = hydro_scan.reduce(function (prev, current) {
            return (parseInt(prev.stupen) > parseInt(current.stupen)) ? prev : current
          });

          this.hydroVystrahaStupen = max_vystraha.stupen;
          let add_color = '';
          if (this.hydroVystrahaStupen === 1) {
            add_color = ' text-color-black';
          }
          this.class_hydro_vystraha = 'vystraha-' + this.hydroVystrahaStupen + add_color + ' border-vystraha-' + this.hydroVystrahaStupen;
          is_vystraha = true;
        } else {
          this.class_hydro_vystraha = null;
          this.hydroVystrahaStupen = 0;
        }

      }


      // OKO VYSTRAHY
      if (this.isVystrahyLoaded && this.vystrahyData.ko_warnings.length > 0) {

        let ko_max_vystraha = this.vystrahyData.ko_warnings.reduce(function(prev, current) {
          return (prev.typ_vystrahy.id > current.typ_vystrahy.id) ? prev : current
        });

        if (parseInt(ko_max_vystraha.typ_vystrahy.id) === 1) {
          this.koVystrahaStupen = 2;
          this.class_ko_vystraha = 'vystraha-2 border-vystraha-2';
        }
        if (parseInt(ko_max_vystraha.typ_vystrahy.id) === 2) {
          this.koVystrahaStupen = 3;
          this.class_ko_vystraha = 'vystraha-3 border-vystraha-3';
        }

        is_vystraha = true;
      } else {
        this.koVystrahaStupen = 0;
        this.class_ko_vystraha = null;
      }


      return is_vystraha;

    },
  },
  methods: {
    onPageInit: function() {
      this.pageReload(null, true);
    },
    onPageBeforeIn: function() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      this.loadSelectedAreas();

      if (isInit || (this.$moment().unix() - this.vystrahyLastUpdated) > 60) {
        this.loadVystrahy();
      }

    },
    loadSelectedAreas: function() {
      const self = this;
      self.selectedMeteoVystrahyRegion = this.$ls.get('meteo_warnings_selected_region');
      self.selectedHydroVystrahyRegion = this.$ls.get('hydro_warnings_selected_region');
    },
    loadVystrahy: function() {
      const self = this;

      let cached = self.$ls.get('all_vystrahy');
      if (cached !== null) {
        self.vystrahyData = cached;
        self.isVystrahyLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'global/getwarnings', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.vystrahyData = response.data;
                self.isVystrahyLoaded = true;
                self.vystrahyLastUpdated = self.$moment().unix();
                self.$ls.set('all_vystrahy', self.vystrahyData, 50 * 1000); //  50 sekund

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o výstrahách', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
  }

}
</script>

<style lang="scss">
.img-home {
  width: auto;
  height:100%;
  max-height: 70px;
}

.shmu-home {
  max-width: 550px;
  margin:0px auto;
}

.shmu-home-buttons {
  display:flex;
  flex-wrap: wrap;
  padding: 0 5px;

  a.button {
    /* display: flex; */
    margin: 5px;
    height: 70px;
    flex-basis: 130px;
    flex-grow: 1;
    width:130px;
    text-align: center;
    div {
      line-height: 20px;
    }
    &.full {
      width:300px;
      flex-basis:300px;
    }
  }
}

.shmu-vystrahy-buttons {
  display:flex;
  flex-wrap: wrap;

  a.button {
    /* display: flex; */
    margin: 5px;
    height: 60px;
    flex-basis: 130px;
    flex-grow: 1;
    width:130px;
    text-align: center;
    div {
      line-height: 20px;
    }
    &.full {
      width:300px;
      flex-basis:300px;
    }
  }
}

.blockx {
  padding: 0 5px;
}

</style>
